"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const ContractInput = (props) => {
    const { name, controller = "contracts", related = "address", data = {} } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const handleChange = (_event, option) => {
        form.setValue(name, option?.id ?? 0, { shouldDirty: true });
        form.setValue(`contract.${related}`, option?.address ?? "0x");
        form.setValue("contract.decimals", option?.decimals ?? 0);
    };
    return (0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: name, controller: controller, fetchData: data, onChange: handleChange, autoSelect: true });
};
exports.ContractInput = ContractInput;
//# sourceMappingURL=index.js.map